// inputNode.js

import { BaseNode } from './BaseNode';
import { Position } from 'reactflow';

export const InputNode = ({ id, data }) => {
  const handles = [
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-value`,
      style: { right: '-4px' }
    }
  ];

  const fields = [
    {
      name: 'inputName',
      label: 'Name',
      type: 'text',
      defaultValue: data?.inputName || id.replace('customInput-', 'input_')
    },
    {
      name: 'inputType',
      label: 'Type',
      type: 'select',
      defaultValue: data.inputType || 'Text',
      options: [
        { value: 'Text', label: 'Text' },
        { value: 'File', label: 'File' }
      ]
    }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      type="customInput"
      title="Input"
      handles={handles}
      fields={fields}
    />
  );
};
